import { type RootState } from "app";
import { useAppSelector } from "app/redux-store-interactions";
import { type SettingsSectionId } from "components/window/core/settings/constants";

export const selectSettingsSectionVisibility = (state: RootState) => state.settingsSectionVisibility;

export const selectIsSettingsSectionVisible = (state: RootState, sectionId: SettingsSectionId): boolean =>
    state.settingsSectionVisibility[sectionId] ?? true;

/** One store subscription for callers that check several sections, such as the Settings window. */
export function useIsSettingsSectionVisible(): (sectionId: SettingsSectionId) => boolean {
    const visibility = useAppSelector(selectSettingsSectionVisibility);
    return (sectionId) => visibility[sectionId] ?? true;
}
